import { useEffect, useState } from "react";

export default function useGetClinicIdsList(): string[] {
  const [clinicIdList, setClinicIdList] = useState<string[]>([]);

  const getElementClinicIds = (): string[] => {
    const element = document?.getElementById("df-chat-details");
    const clinicIds = element?.getAttribute("clinic-ids");

    return clinicIds ? JSON.parse(clinicIds) : ["58ff6485421aa9383b00000a"];
  };

  useEffect(() => {
    if (clinicIdList.length === 0) {
      setClinicIdList(getElementClinicIds());
    }
  }, [clinicIdList]);

  return clinicIdList;
}
